import { Container } from "react-bootstrap";

export default function TreatmentHero({ title }) {
  return (
    <section className="hero bg-light py-5 text-center">
      <Container>
        <h1 className="fw-bold display-4 pb-3">{title} In Pimpri-Chinchwad</h1>
        <p className="text-muted fs-4">Home - Treatments - <span style={{ color: "#D25239" }}>{title}</span></p>
      </Container>
    </section>
  );
}
